import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoading, TailSpin, } from '@agney/react-loading';
import { AuthContext } from '../../services/AuthContext';
import { Recipes, Search, Favorites, InsertionDialog, Sidebar, MobileSidebar } from '../../components';
import './styles.sass';


const Dashboard = () => {
    const [activeScreen, setActiveScreen] = useState('main');
    const [open, setOpen] = useState(false);
    const [prevScreen, setPrevScreen] = useState('');
    const [showRecipe, setShowRecipe] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const prevState = useRef(null);
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <TailSpin width="50" color="#FFFFFF" />
    });

    const renderScreen = () => {
        switch (true) {
            case (activeScreen === 'main' || prevScreen === 'main'):
                return (
                    <Recipes
                        showRecipe={showRecipe}
                        setShowRecipe={setShowRecipe}
                    />
                );
            case (activeScreen === 'favorites' || prevScreen === 'favorites'):
                return (
                    <Favorites
                        showRecipe={showRecipe}
                        setShowRecipe={setShowRecipe}
                    />
                );
            case (activeScreen === 'search' || prevScreen === 'search'):
                return (
                    <Search
                        showRecipe={showRecipe}
                        setShowRecipe={setShowRecipe}
                    />
                );
            default:
                return null;
        }
    }

    useEffect(() => {
        if (!user) {
            navigate('/', { replace: true });
            return;
        }
        // Authorized user
        document.title = `CookEat - ${user.email}'s dashboard`;
        prevState.current = activeScreen;
        if (prevState.current !== 'add')
            setPrevScreen(prevState.current);
        setTimeout(() => {
            setLoaded(true);
        }, 1000);
    }, [user, navigate, activeScreen]);

    return loaded ? (
        <>
            <div className='dashboard-container'>
                <Sidebar
                    activeScreen={activeScreen}
                    setActiveScreen={setActiveScreen}
                    setOpen={setOpen}
                    showRecipe={showRecipe}
                    setShowRecipe={setShowRecipe}
                />
                {renderScreen()}
            </div>
            <MobileSidebar
                activeScreen={activeScreen}
                setActiveScreen={setActiveScreen}
                setOpen={setOpen}
                showRecipe={showRecipe}
                setShowRecipe={setShowRecipe}
            />
            <InsertionDialog
                activeScreen={activeScreen}
                setActiveScreen={setActiveScreen}
                open={open}
                setOpen={setOpen}
            />
        </>
    ) : (
        <div className='loading-container'>
            <section className="indicator" {...containerProps}>
                {indicatorEl}
            </section>
        </div>
    )
}

export default Dashboard;